import React, { useContext, useEffect, useState } from 'react'
import OwlCarousel from "react-owl-carousel";
import { Field, Form, Formik } from 'formik';
import { useLocation } from 'react-router-dom';
import { getImages } from '../../Components/Const';
import { VehicleContext } from '../../Components/Context/VehicleContext';
import Fancybox from '../../Components/Front/Fancybox';
import { ValidationError } from '../../Components/Errors/ValidationError';
import FrontLayout from '../../Components/Layouts/FrontLayout';
import Breadcrumb from '../../Components/Frontend/Common/Breadcrumb';

const InventoryDetail = () => {
    const optionsVdp = {
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            600: {
                items: 2,
                margin: 20
            },
            768: {
                items: 3,
                margin: 25
            },
            1000: {
                items: 3,
                margin: 25
            }
        },
    };

    const queryParameters = new URLSearchParams(window.location.search);
    const vehicleVIN = queryParameters.get("vin");

    const { vehiclesByVIN, numberFormatter, submitContactForm } = useContext(VehicleContext);

    const defaultVehicleData = {
        exterior_color: "Gray",
        interior_color: "Rosso Ferrari",
        mileage: 2201,
        options_msrp: "42135",
        post_settings: null,
        price: "329000",
        stockno: "1017",
        tol: 23,
        year: 2021,
        make: "Ferrari",
        model: "812GTS",
        trim: "Base",
        vdp_hero_image: getImages('hero-img.png'),
        vehicle_name: "2018 Ferrari 488 Spider",
        vin: "ZFF97CMA4M0261467",
        body_style: "2D Convertible",
        description: "This one of a kind machine  clocks 0 - 60 in 4.5 seconds only one previous owner and only 600 have ever been made.  Its the perfect perfect piece for any collector lorem ipsum dolor sit amet, adipiscing elit, duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. sed dompor aliqua",
        images: [getImages('vdp-thumb1.jpg'), getImages('vdp-thumb2.jpg'), getImages('vdp-thumb3.jpg'), getImages('vdp-thumb4.jpg'), getImages('vdp-thumb5.jpg'), getImages('vdp-thumb6.jpg'), getImages('vdp-thumb7.jpg'), getImages('vdp-thumb8.jpg'), getImages('vdp-thumb9.jpg'), getImages('vdp-thumb10.jpg'), getImages('vdp-thumb11.jpg'), getImages('vdp-thumb12.jpg')],
        gallery_images: [[getImages('vdp-thumb1.jpg'), getImages('vdp-thumb2.jpg')], [getImages('vdp-thumb3.jpg'), getImages('vdp-thumb4.jpg')], [getImages('vdp-thumb5.jpg'), getImages('vdp-thumb6.jpg'), getImages('vdp-thumb7.jpg'), getImages('vdp-thumb8.jpg'), getImages('vdp-thumb9.jpg'), getImages('vdp-thumb10.jpg'), getImages('vdp-thumb11.jpg'), getImages('vdp-thumb12.jpg')]]

    };

    const [vehicleData, setVehicleData] = useState(defaultVehicleData);

    const [vehicleExist, setVehicleExist] = useState(false);



    useEffect(() => {
        var vehicle_data = vehicleVIN && vehiclesByVIN && vehicleVIN in vehiclesByVIN ? vehiclesByVIN[vehicleVIN] : defaultVehicleData;
        const split_index = Math.ceil((vehicle_data.images.length - 1) / 2);
        
        if(split_index > 0) {
            //var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
            //    return (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
            //}, []);
            //console.log(vehicle_data.images.length-1,split_index);

            var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                console.log(index,split_index,rows);
                return (index < split_index || vehicle_data.images.length-1 <= 3 ? rows.push([key]) : rows[index - split_index].push(key)) && rows;
            }, []);

            //console.log(split_index,gallery_images);

            vehicle_data.gallery_images = gallery_images;
        } else
            vehicle_data.gallery_images = vehicle_data.images.slice(1);

        setVehicleData(vehicle_data);
        if (vehiclesByVIN) setVehicleExist(true);
    }, [vehicleVIN, vehiclesByVIN]);

    //  UseLocation
    const location = useLocation();

    useEffect(() => {
        // Function to scroll to the section
        const scrollToSection = () => {
            const hash = location.hash;
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        // Scroll after a slight delay to ensure DOM updates are complete
        const timeoutId = setTimeout(scrollToSection, 2000);

        // Clean up the timeout if the component unmounts
        return () => clearTimeout(timeoutId);
    }, [vehicleData]);

    // Is Loaded
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    useEffect(() => {
        setTimeout(() => {
            setIsDataLoaded(false);
        }, 2000);
    }, [vehicleData]);

    
    const [tooltipVisible, setTooltipVisible] = useState(null);
    const handleCopy = (vin) => {
        const textArea = document.createElement('textarea');
        textArea.value = vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip(vin);
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };

    const showTooltip = (vin) => {
        setTooltipVisible(vin);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };
    return (
        vehicleExist &&
        <>
            <FrontLayout>
                {isDataLoaded ?
                    <div className='py-5 my-5 text-center'>
                        <img src={getImages('gears_green.svg')} alt='gears' />
                    </div> :
                    <section className='vdp-main' style={{
                        background: `#fff url(${getImages('hero-bg.png')}) no-repeat center top`,
                        backgroundSize: '100%'
                    }}>
                        
                        <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                            <section className='vdp-banner pt-4'>
                                <div className='container mxw-1366'>
                                    <Breadcrumb/>
                                    <div className='d-flex vdp-banner-flex align-items-center'>
                                        <div className='w-60 mt-3 wow fadeInLeft ps-5' data-wow-delay="0.2s">
                                            {vehicleData.vdp_hero_image ? 
                                                <a data-fancybox="gallery" href={vehicleData.vdp_hero_image}>
                                                    <img src={vehicleData.vdp_hero_image} alt='hero' />
                                                </a> :
                                                <div className='no-vdp-box position-relative'>
                                                    <img 
                                                        src={getImages('vdp-no-image.jpg')} 
                                                        alt="No VDP" 
                                                    />
                                                </div>
                                            }
                                        </div>
                                        <div className='w-40 ps-5 pe-4 wow fadeInRight' data-wow-delay="0.4s">
                                            <div className='d-flex align-items-center mb-4'>
                                                <div className='brand-logo'>
                                                    <img src={getImages(`logos/${vehicleData.make}.png`)} />
                                                </div>
                                                <div className='brand-name ps-3 text-uppercase'>
                                                    {vehicleData.make}
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-end justify-content-between vdp-banner-info'>
                                                <div className='mb-2'>
                                                    <div className='vdp-md-title mb-3 text-dark-blue'>{vehicleData.year} {vehicleData.make}</div>
                                                    <div className='sm-title mb-3 text-black font-1-2em'>{vehicleData.model} {vehicleData.trim}</div>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='xs-title text-gray font-1-1em fw-400'>Miles: {numberFormatter(vehicleData.mileage)}</div>
                                                        {/* <div className='d-md-none'>
                                                            <div className='d-inline-flex align-items-center mb-3'>
                                                                <span className='xs-title pe-2 text-gray'>Price</span>
                                                                <span className='vdp-md-title text-black'>{numberFormatter(vehicleData.price, true)}</span>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className='mb-2 text-center'>
                                                    {/* <div className='d-none d-md-block'>
                                                        <div className='d-inline-flex align-items-center mb-3'>
                                                            <div className='xs-title pe-2 text-gray'>Price</div>
                                                            <div className='vdp-md-title text-black'>{numberFormatter(vehicleData.price, true)}</div>
                                                        </div>
                                                    </div> */}
                                                    <div>
                                                        <button className='blue-btn lg-btn'>Inquire</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className='vdp-gallery-wrap'>
                                <div className='container mxw-1366'>
                                    <div className='vdp-gallery-tab'>
                                        <div className="tab-content wow zoomIn" data-wow-delay="0.6s">
                                            <div className="tab-pane fade show active">
                                                <OwlCarousel
                                                    className="owl-theme galler-slider common-arrow"
                                                    loop={false}
                                                    margin={25}
                                                    items={4}
                                                    dots={false}
                                                    nav={true}
                                                    {...optionsVdp}
                                                >
                                                    {vehicleData.gallery_images.map((v, i) => {
                                                        return (
                                                            <div className='item' key={i}>
                                                                {v.map((w, j) => {
                                                                    return (
                                                                        <div className='gallery-box mb-25' key={j}>
                                                                            <a data-fancybox="gallery" href={w} className='position-relative'>
                                                                                <img src={w} alt='thumb' />
                                                                            </a>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        )
                                                    })}
                                                </OwlCarousel>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='vdpa-block mt-5 row'>
                                        <div className='col-md-4 order-2'>
                                            <div className='vdpa-box p-4 h-100'>
                                                <div className='md-title mb-3 text-black wow fadeInUp' data-wow-delay="0.2s">Vehicle Info</div>
                                                <div className='vdpa-table'>
                                                    <table className='w-100'>
                                                        <tbody>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Stock</th>
                                                                <td>{vehicleData.stockno}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>VIN</th>
                                                                <td className="text-nowrap">
                                                                    <span className='position-relative copy-info'>
                                                                        <button type='button' onClick={()=>handleCopy(vehicleData.vin)} className='btn p-0'><span className=' copy_icon'></span></button>
                                                                        {tooltipVisible === vehicleData.vin && <span className='copy-tooltip'>Copied!</span>} 
                                                                    </span>
                                                                    {vehicleData.vin}
                                                                </td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Year</th>
                                                                <td>{vehicleData.year}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Make</th>
                                                                <td>{vehicleData.make}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Model</th>
                                                                <td>{vehicleData.model}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Mileage</th>
                                                                <td>{numberFormatter(vehicleData.mileage)}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Trim</th>
                                                                <td>{vehicleData.trim}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Body Style</th>
                                                                <td>{vehicleData.body_style}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Transmission</th>
                                                                <td>7-Speed Manual</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Cylinders</th>
                                                                <td>12</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Fuel Type</th>
                                                                <td>Gasoline</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Exterior Color</th>
                                                                <td>{vehicleData.exterior_color}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>Interior Color</th>
                                                                <td>{vehicleData.interior_color}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>CARFAX</th>
                                                                <td>{vehicleData.bad_carfax ? "Has Issues" : "Clean"}</td>
                                                            </tr>
                                                            <tr className='wow fadeInUp' data-wow-delay="0.2s">
                                                                <th>AutoCheck</th>
                                                                <td>{vehicleData.bad_autocheck ? "Has Issues" : "Clean"}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* <div className='d-flex align-items-center justify-content-between mt-5 mb-3 wow fadeInUp vr-block' data-wow-delay="0.2s">
                                                    <div>
                                                        <img src={getImages('carfax.png')} alt='carfax' />
                                                    </div>
                                                    <div className='text-end'>
                                                        <button className='text-dark-blue trans-btn d-inline-block'>View Report</button>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className='col-md-8' id="aboutVdp">
                                            <div className='vdpa-box h-100'>
                                                <div className='main-heading text-uppercase mb-3 text-black wow fadeInUp' data-wow-delay="0.2s">About this Vehicle</div>
                                                <p className='text-gray wow fadeInUp' data-wow-delay="0.4s" dangerouslySetInnerHTML={{ __html: vehicleData.description }}></p>
                                                <div>
                                                    <div className='md-title fw-400 my-5 pt-5 pb-3 wow fadeInUp' data-wow-delay="0.6s">Got a question? <a href="#" className='text-dark-blue'>Call</a> or <a href="#" className='text-dark-blue'>Chat</a> live with a sales representative</div>
                                                    <Formik
                                                        // validationSchema={validationSchema}
                                                        initialValues={{
                                                            full_name: '',
                                                            email: '',
                                                            phone_number: '',
                                                            comments: '',
                                                        }}
                                                        onSubmit={(values, { resetForm }) => {
                                                            console.log(values);
                                                            submitContactForm(values);
                                                            alert("Thank you for your submission");
                                                            resetForm();
                                                        }}
                                                    >
                                                        {({ values, setFieldValue, field, form }) => (
                                                            <Form className="custom-form" autoComplete="off">
                                                                <div className='row'>
                                                                    <div className='col-md-6 wow fadeInUp' data-wow-delay="0.2s">
                                                                        <div className='form-group'>
                                                                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                                <div className='cs-label'>Full Name</div>
                                                                                <div className='cs-require'>* Required</div>
                                                                            </div>
                                                                            <Field
                                                                                type="text"
                                                                                name="full_name"
                                                                                className="form-control"
                                                                            />
                                                                            <ValidationError name="full_name" />
                                                                        </div>
                                                                        <div className='form-group'>
                                                                            <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                                <div className='cs-label'>Email</div>
                                                                                <div className='cs-require'>* Required</div>
                                                                            </div>
                                                                            <Field
                                                                                type="text"
                                                                                name="email"
                                                                                className="form-control"
                                                                            />
                                                                            <ValidationError name="email" />
                                                                        </div>
                                                                        <div className='form-group'>
                                                                            <div className='cs-label mb-2'>Phone Number</div>
                                                                            <Field
                                                                                type="text"
                                                                                name="phone_number"
                                                                                className="form-control"
                                                                            />
                                                                            <ValidationError name="phone_number" />
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-6 wow fadeInUp' data-wow-delay="0.4s">
                                                                        <div className='form-group'>
                                                                            <div className='cs-label mb-2'>Comments</div>
                                                                            <Field
                                                                                as="textarea"
                                                                                name="comments"
                                                                                className="form-control h-218 py-3"
                                                                            />
                                                                            <ValidationError name="comments" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='d-flex align-items-center mt-5 justify-content-between about-action-flex wow fadeInUp' data-wow-delay="0.6s">
                                                                    <div className='md-title fw-400'><span className='phone-icon me-2'></span> 330-329-3633</div>
                                                                    <div>
                                                                        <button className='blue-btn lg-btn w-300' type='submit'>Send</button>
                                                                    </div>
                                                                </div>
                                                            </Form>
                                                        )}
                                                    </Formik>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </Fancybox>
                    </section>
                }
            </FrontLayout>
        </>
    )
}

export default InventoryDetail